import React, { useEffect, useState } from 'react';
import DialogModal from '../../../Modal/DialogModal/DialogModal';
import useWindowResize from 'hooks/useWindowResize';
import './HotspotModal.scss';
import { getTypeLabel } from "../../../../utils/accessibilityHelpers";
import AFramePanoramaV2 from "../../../AFrame/AFramePanoramaV2";
import * as constants from "../../../../constants";

const PanoHotspotModal = ({
  pano,
  title,
  isBeingEdited = false,
  primaryColor,
  showModal,
  closeModal,
}) => {
  const [styles, setStyles] = useState({});
  const [autoRotate, setAutoRotate] = useState(pano.autoRotate);
  const windowSize = useWindowResize('a-canvas');

  useEffect(() => {
    if (Object.keys(windowSize).length !== 0) {
      const height = isBeingEdited
        ? parseInt(windowSize.height) - 48 + 'px'
        : windowSize.height;
      setStyles({
        overlay: {
          width: windowSize.width,
          height: height,
          top: 'auto',
          left: 'auto',
        },
      });
    }
  }, [isBeingEdited, showModal, windowSize]);

  return (
    <div
      className="hotspot-media-modal__wrapper"
    >
      <DialogModal
        aria={{
          label: `${getTypeLabel(constants.PANOS)} hotspot modal`,
        }}
        className="hotspot-media-modal"
        closeModal={closeModal}
        data-testid="pano-hotspot-modal"
        isOpen={showModal}
        shouldCloseOnOverlayClick
        styles={styles}
      >
        <article id="hotspot-media-modal__title-wrapper">
          {!!pano.name && <h4 className="hotspot-media-modal__name">{title}</h4>}
          <div id="hotspot-media-modal__media-wrapper" className={constants.PANOS}>
            <AFramePanoramaV2 pano={{ ...pano, autoRotate }} primaryColor={primaryColor} setAutoRotate={setAutoRotate} />
          </div>
        </article>
      </DialogModal>
    </div>
  );
};

export default PanoHotspotModal;
